import { render, staticRenderFns } from "./TableReportConfigs.vue?vue&type=template&id=77b2017b&"
import script from "./TableReportConfigs.vue?vue&type=script&lang=js&"
export * from "./TableReportConfigs.vue?vue&type=script&lang=js&"
import style0 from "./TableReportConfigs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports